import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CalendarX2, Trash2 } from "lucide-react";

const fmtDay = (ymd) => {
  const [y, m, d] = ymd.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d, 12)).toLocaleDateString("es-ES", {
    weekday: "long", day: "2-digit", month: "long", timeZone: "UTC",
  });
};

// Asked when the user hits the red button on a day card in the week view.
// `target` = { appointment, ymd }. Recurring/ranged series offer "skip only
// this day"; deleting the whole series is only offered when `onDelete` exists
// (admin).
export default function AppointmentDayActionDialog({ target, onClose, onSkipDay, onDelete }) {
  const a = target?.appointment;
  const ymd = target?.ymd;
  const isSeries = Boolean(a && ((a.weekdays?.length > 0) || (a.start_date && a.end_date)));
  return (
    <Dialog open={Boolean(target)} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-sm bg-card border-border" data-testid="appt-day-action-dialog">
        <DialogHeader>
          <DialogTitle className="text-white">{a?.passenger_name || "Cita"}</DialogTitle>
          <DialogDescription className="text-xs">
            {ymd ? fmtDay(ymd) : ""} · {String(a?.hour ?? 0).padStart(2, "0")}:{String(a?.minute ?? 0).padStart(2, "0")}
            {isSeries && <span className="block mt-1 text-muted-foreground">Esta cita se repite. ¿Qué quieres hacer?</span>}
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-2">
          {isSeries && onSkipDay && (
            <Button
              variant="outline"
              className="justify-start border-amber-500/40 text-amber-300 hover:bg-amber-500/10 h-auto py-2"
              onClick={() => { onSkipDay(a, ymd); onClose(); }}
              data-testid="appt-day-skip-btn"
            >
              <CalendarX2 className="w-4 h-4 mr-2 shrink-0" />
              <span className="text-left">
                <span className="block font-bold">Quitar solo este día</span>
                <span className="block text-[11px] font-normal text-muted-foreground">El resto de la serie sigue igual. Se puede deshacer.</span>
              </span>
            </Button>
          )}
          {onDelete && (
            <Button
              variant="outline"
              className="justify-start border-red-500/40 text-red-300 hover:bg-red-500/10 h-auto py-2"
              onClick={() => { onDelete(a); onClose(); }}
              data-testid="appt-day-delete-series-btn"
            >
              <Trash2 className="w-4 h-4 mr-2 shrink-0" />
              <span className="text-left">
                <span className="block font-bold">{isSeries ? "Eliminar toda la serie" : "Eliminar la cita"}</span>
                <span className="block text-[11px] font-normal text-muted-foreground">Va a la papelera; un admin puede restaurarla.</span>
              </span>
            </Button>
          )}
          <Button variant="ghost" onClick={onClose} data-testid="appt-day-cancel-btn">Cancelar</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
